const INIT_STATE = {
  selectedDepartment: {},
  department:[]
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case "SELECTED_DEPARTMENT": {
      return {
        ...state,
        selectedDepartment: action.payload
      };
    }
    case "FETCH_DEPARTMENT": {
      return {
        ...state,
        department: action.payload
      };
    }
    default:
      return state;

  }
}


